<template>
  <div>
    <div v-if="currentDisplayType == 'simple'">
      <el-row>
        <el-col :span="14">
          <span>应付价格(除手续费): </span>
        </el-col>
        <el-col :span="10" class="align-right">
          <span v-if="optionModel.isAutonomousModel">{{dataModel.amount + dataModel.amountTax + data.paidServiceCharge | toCurrency}}</span>
          <span v-else>{{dataModel.amount + dataModel.amountTax | toCurrency}}</span>
        </el-col>
      </el-row>
      <el-row v-if="!!dataModel.balanceInStore">
        <el-col :span="14">
          <span>已存余额: </span>
        </el-col>
        <el-col :span="10" class="align-right">
          <span>{{dataModel.balanceInStore | toCurrency}}</span>
        </el-col>
      </el-row>
      <el-row class="cs-redLabel">
        <el-col :span="14">
          <span>已付款: </span>
        </el-col>
        <el-col :span="10" class="align-right">
          <span v-if="optionModel.isAutonomousModel">-{{dataModel.paidAmount + dataModel.paidAmountTax + data.paidServiceCharge | toCurrency}}</span>
          <span v-else>-{{dataModel.paidAmount + dataModel.paidAmountTax | toCurrency}}</span>
        </el-col>
      </el-row>
      <el-row v-if="!!dataModel.excessAmount">
        <el-col :span="14">
          <span>超出金额: </span>
        </el-col>
        <el-col :span="10" class="align-right">
          <span>{{dataModel.excessAmount | toCurrency}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14">
          <span>待付款(除手续费): </span>
        </el-col>
        <el-col :span="10" class="align-right">
          <span>{{dataModel.debt | toCurrency}}</span>
        </el-col>
      </el-row>
    </div>
    <div v-if="currentDisplayType == 'simple2'">
      <el-row>
        <el-col :span="14">
          <span>应付价格(除手续费): </span>
        </el-col>
        <el-col :span="10" class="align-right">
          <span v-if="optionModel.isAutonomousModel">{{dataModel.amount + dataModel.amountTax + data.paidServiceCharge | toCurrency}}</span>
          <span v-else>{{dataModel.amount + dataModel.amountTax | toCurrency}}</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import bonusPointMechanismVue from "../../page/admin/bonusPointMechanism.vue";

export default {
  props: {
    options: {
      displayType: String,
      isAutonomousModel: Boolean,
    },
    data: {
      amount: Number,
      paidAmount: Number,
      paidAmountTax: Number,
      paidServiceCharge: Number,
      excessAmount: Number,
      debt: Number,
      balanceInStore: Number,
      isAutonomous: Boolean,
    },
  },
  data() {
    return {
      displayTypes: ["normal", "simple", "simple2"],
      optionModel: {
        displayType: "normal",
        isAutonomousModel: false,
      },
      dataModel: {
        amount: 0,
        paidAmount: 0,
        paidAmountTax: 0,
        paidServiceCharge: 0,
        excessAmount: 0,
        debt: 0,
        balanceInStore: 0,
        isAutonomous: false,
      },
    };
  },
  components: {},
  computed: {
    currentDisplayType: function () {
      let result = "normal";

      if (!!this.options.displayType) {
        for (let i = 0; i < this.displayTypes.length; i++) {
          if (this.displayTypes[i] == this.options.displayType.toLowerCase()) {
            result = this.displayTypes[i];
            break;
          }
        }
      }

      return result;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.reloadOptionModel();
      this.reloadDataModel();
    },
    reloadOptionModel(options) {
      if (!options) options = this.options;

      if (!!options) {
        this.optionModel.displayType = options.displayType;
        this.optionModel.isAutonomousModel = options.isAutonomousModel;
      } else {
        this.optionModel.displayType = "normal";
        this.optionModel.isAutonomousModel = false;
      }
    },
    reloadDataModel(data) {
      if (!data) data = this.data;

      if (!!data) {
        this.dataModel.amount = data.amount;
        this.dataModel.amountTax = data.amountTax;
        if (!this.dataModel.amountTax) {
          this.dataModel.amountTax = 0;
        }
        this.dataModel.paidAmount = data.paidAmount;
        this.dataModel.paidAmountTax = data.paidAmountTax;
        if (!this.dataModel.paidAmountTax) {
          this.dataModel.paidAmountTax = 0;
        }
        this.dataModel.paidServiceCharge = data.paidServiceCharge;
        if (!this.dataModel.paidServiceCharge) {
          this.dataModel.paidServiceCharge = 0;
        }
        this.dataModel.excessAmount = data.excessAmount;
        this.dataModel.debt = data.debt;
        this.dataModel.balanceInStore = data.balanceInStore;
        this.dataModel.isAutonomous = data.isAutonomous;
      } else {
        this.dataModel.amount = 0;
        this.dataModel.amountTax = 0;
        this.dataModel.paidAmount = 0;
        this.dataModel.paidAmountTax = 0;
        this.dataModel.paidServiceCharge = 0;
        this.dataModel.excessAmount = 0;
        this.dataModel.debt = 0;
        this.dataModel.balanceInStore = 0;
        this.dataModel.isAutonomous = false;
      }
    },
  },
  watch: {
    options: function (newVal) {
      this.reloadOptionModel(newVal);
    },
    data: function (newVal) {
      this.reloadDataModel(newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/finance/accountInfo.vue